import { CURRENT_ORGANIZATION_ID_KEY, CURRENT_PROJECT_ID_KEY, CURRENT_WORKSPACE_ID_KEY } from 'state_management/threadedConstants';

export const GET_CURRENT_PROJECT_ID = (): string => {
  return sessionStorage.getItem(CURRENT_PROJECT_ID_KEY) ?? '';
};
export const SET_CURRENT_PROJECT_ID = (id: string) => {
  sessionStorage.setItem(CURRENT_PROJECT_ID_KEY, id);
};
export const GET_CURRENT_WORKSPACE_ID = (): string => {
  return sessionStorage.getItem(CURRENT_WORKSPACE_ID_KEY) ?? '';
};
export const SET_CURRENT_WORKSPACE_ID = (id: string) => {
  sessionStorage.setItem(CURRENT_WORKSPACE_ID_KEY, id);
};
export const SET_CURRENT_ORGANIZATION_ID = (id: string) => {
  sessionStorage.setItem(CURRENT_ORGANIZATION_ID_KEY, id);
};
